import type { Graph, UserSettingsRow } from '@/schema/estate';

export interface CaptureContext {
  estateId: string;
  itemGroupId: string;
  categoryId: string;
}

const EMPTY: CaptureContext = { estateId: '', itemGroupId: '', categoryId: '' };

export function getCaptureContext(g: Graph, userId: string): CaptureContext {
  const row = g.user_settings.all().find((s) => s.id === userId);
  if (!row) return { ...EMPTY };
  return {
    estateId: row.current_estate_id,
    itemGroupId: row.current_item_group_id,
    categoryId: row.current_category_id,
  };
}

export async function setCaptureContext(
  g: Graph,
  userId: string,
  patch: Partial<CaptureContext>,
): Promise<void> {
  const existing = g.user_settings.all().find((s) => s.id === userId);
  if (!existing) {
    await g.user_settings.create({
      id: userId,
      owner_group_id: userId,
      current_estate_id: patch.estateId ?? '',
      current_item_group_id: patch.itemGroupId ?? '',
      current_category_id: patch.categoryId ?? '',
    });
    return;
  }
  const changes: Partial<
    Pick<UserSettingsRow, 'current_estate_id' | 'current_item_group_id' | 'current_category_id'>
  > = {};
  if (patch.estateId !== undefined) changes.current_estate_id = patch.estateId;
  if (patch.itemGroupId !== undefined) changes.current_item_group_id = patch.itemGroupId;
  if (patch.categoryId !== undefined) changes.current_category_id = patch.categoryId;
  if (Object.keys(changes).length > 0) await g.user_settings.update(existing.id, changes);
}
